import React from "react" ;
import ApprovalsAppBodyHeader from "./ApprovalsAppBodyHeader";
import {Route, Switch} from "react-router-dom";
import {PATH_APPROVALS_ROOT, PATH_HOME_ROOT} from "root/Wieldy/routePaths";
import ScrollRails from "../../Common/Body/ScrollRails";
import ApprovalsTab from "root/Wieldy/ApplicationModules/Approvals/Body/ApprovalsTab";
import MessagingTab from "root/Wieldy/ApplicationModules/Messaging/Body/MessagingTab";

const ApprovalsAppBody= (props) =>
{
    return (
    <div className="dt-module__container">
        <ApprovalsAppBodyHeader />
        <div className="dt-module__content ps-custom-scrollbar ps" style={{height: props.height, width: props.width}}>
            <div className="dt-module__content-inner">
                <div className="dt-module__list">
                    <Switch>
                        <Route path={PATH_APPROVALS_ROOT}render={(thisprops) => <ApprovalsTab post_id='' {...thisprops}/>}/>
                        <Route path={PATH_HOME_ROOT} render={(thisprops) => <ApprovalsTab post_id='' {...thisprops}/>}/>
                    </Switch>
                </div>
            </div>
            <ScrollRails />
        </div>
    </div>
    ) ;
}

export default ApprovalsAppBody;
